import React, { FC } from "react"
import { RRButtonFooter } from "../../atoms/roundedrectangle/RRButtonFooter"
import { StatusBubble } from "../../atoms/Atoms"
import { RRIconBar } from "../../atoms/roundedrectangle/RRIconBar"
import { RoundedRectangle } from "../../atoms/roundedrectangle/RoundedRectangle"
import L10n from "../../../../lib/carrot-l10n"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../../atoms/Bodies"
import { CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"
import { useBenefitEnrollment } from "components/context/enrollment/BenefitEnrollmentContext"
import { BenefitAvailabilityStatus } from "types/benefitEnrollmentStatus"
import { useHistory } from "react-router-dom"
import moment from "moment"
import Locations from "components/views/home/navigation"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const CarrotCardNeedsEnrollmentModule: FC<CarrotCardModuleProps> = () => {
  const { availabilityStatus, status } = useBenefitEnrollment()
  const history = useHistory()

  const onClickUpdate = (): void => history.push(Locations.Home.EnrollmentFlowActive)

  const expired = availabilityStatus === BenefitAvailabilityStatus.ENROLLMENT_PLAN_EXPIRED

  const bodyMessage = expired
    ? `Your Carrot Card and funds have been locked because your insurance plan info expired ${
        status.enrollmentExpirationDate ? moment(status.enrollmentExpirationDate).format("MMMM Do, YYYY") : ""
      }`
    : "Your Carrot benefit has been updated. To access your funds, you'll need to share some information about your insurance plan."

  const buttonLabel = expired ? "Update plan info" : "Share plan info"

  return (
    <RoundedRectangle backgroundColor="red-orange-white">
      <RRIconBar
        iconName="icn-carrot-cards"
        iconBackgroundColor="roman-red-40"
        label={<StatusBubble backgroundColor="roman-red" status={l`carrotCard.status.locked`} />}
      />
      <H3 variant="primary" stack="tiny">{l`carrotCard`}</H3>
      <BodySmall color="black-80">{bodyMessage}</BodySmall>
      <RRButtonFooter onClick={onClickUpdate} outline>
        {buttonLabel}
      </RRButtonFooter>
    </RoundedRectangle>
  )
}

export { CarrotCardNeedsEnrollmentModule }
